<p-dialog [header]="headerTitle" [(visible)]="displayDialog" (onHide)="closeDialog()" [modal]="true" [responsive]="true"
    [closable]="true" [style]="{width: '70vw'}">
    <form [formGroup]="addToModuleForm" novalidate>
    <!-- Step Indicator -->
    <div class="p-mb-3 step-indicator">
      <div class="p-d-flex p-ai-center p-jc-center">
        <div class="p-d-flex p-ai-center">
          <div class="p-mr-2">
            <span class="p-badge p-badge-lg" [ngClass]="{'p-badge-primary': currentStep === 1, 'p-badge-secondary': currentStep !== 1}">1</span>
          </div>
          <span class="p-mr-3 step-label" [ngClass]="{'active': currentStep === 1}">Select Workbook Row</span>
        </div>
        <div class="p-mr-3 step-arrow">
          <i class="pi pi-arrow-right"></i>
        </div>
        <div class="p-d-flex p-ai-center">
          <div class="p-mr-2">
            <span class="p-badge p-badge-lg" [ngClass]="{'p-badge-primary': currentStep === 2, 'p-badge-secondary': currentStep !== 2}">2</span>
          </div>
          <span class="step-label" [ngClass]="{'active': currentStep === 2}">Field Mapping</span>
        </div>
      </div>
    </div> 
    <div class="card">
        <div class="p-grid">
           

            <!-- Source Workspace and Workbook fields -->
            <div class="p-col-12 p-lg-6">
                <label><span *ngIf="isCopyMoveWBRow">Source</span> Workspace <span style="color: red;">*</span></label>
                <p-dropdown [options]="workspaceList" formControlName="selectedWorkspace" optionLabel="name"
                    optionValue="id" [filter]="true" placeholder="Select Workspace" appendTo="body" [ngClass]="{'p-disabled': true}"
                    (onChange)="onWorkspaceChange($event)">
                </p-dropdown>
                <div *ngIf="detailsFormErrors?.selectedWorkspace" class="p-invalid">
                    <small>{{ detailsFormErrors?.selectedWorkspace }}</small>
                </div>
            </div>
            <div class="p-col-12 p-lg-6">
                <label><span *ngIf="isCopyMoveWBRow">Source</span> Workbook <span style="color: red;">*</span></label>
                <p-dropdown [options]="workBookList" formControlName="selectedWorkbook" optionLabel="name"
                    optionValue="id" [filter]="true" placeholder="Select Workbook" appendTo="body"
                    (onChange)="onWorkbookChange($event)" [ngClass]="{'p-disabled': true}">
                </p-dropdown>
                <div *ngIf="detailsFormErrors?.selectedWorkbook" class="p-invalid">
                    <small>{{ detailsFormErrors?.selectedWorkbook }}</small>
                </div>
            </div>

             <!-- Module and Channel fields - only show when not in copy/move mode -->
             <ng-container *ngIf="!isCopyMoveWBRow">
              <div class="p-col-12 p-lg-6">
                  <label>Module <span style="color: red;">*</span></label>
                  <p-dropdown [options]="modulesList" formControlName="selectedModule" optionLabel="name"
                      optionValue="id" [filter]="true" placeholder="Select Module" appendTo="body"
                      (onChange)="getChannels()">
                  </p-dropdown>
                  <div *ngIf="detailsFormErrors?.selectedModule" class="p-invalid">
                      <small>{{ detailsFormErrors?.selectedModule }}</small>
                  </div>
              </div>
              <div class="p-col-12 p-lg-6">
                  <label>Channel <span style="color: red;">*</span></label>
                  <p-dropdown 
                      [options]="moduleChannels" 
                      formControlName="selectedChannel" 
                      optionLabel="name"
                      optionValue="id" 
                      [filter]="true" 
                      placeholder="Select Channel" 
                      appendTo="body"
                      (onChange)="onChannelChange($event)"
                      [ngClass]="{'ng-invalid ng-dirty': detailsFormErrors['selectedChannel']}">
                  </p-dropdown>
                  <div *ngIf="detailsFormErrors?.selectedChannel" class="p-invalid">
                      <small>{{ detailsFormErrors?.selectedChannel }}</small>
                  </div>
              </div>
          </ng-container>

            <!-- Target Workspace and Workbook fields - only show in copy/move mode -->
            <ng-container *ngIf="isCopyMoveWBRow">
                <div class="p-col-12 p-lg-6">
                    <label>Target Workspace <span style="color: red;">*</span></label>
                    <p-dropdown [options]="workspaceList" formControlName="selectedTargetWorkspace" optionLabel="name"
                        optionValue="id" [filter]="true"  [ngClass]="{'p-disabled': isCreateDuplicateRow}" placeholder="Select Target Workspace" appendTo="body"
                        (onChange)="onTargetWorkspaceChange($event)" showClear="true">
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.selectedTargetWorkspace" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedTargetWorkspace }}</small>
                    </div>
                </div>
                <div *ngIf="addToModuleForm.get('selectedTargetWorkspace')?.value"
                     class="p-col-12 p-lg-6">
                    <label>Target Workbook <span style="color: red;">*</span></label>
                    <p-dropdown [options]="targetWorkBookList" formControlName="selectedTargetWorkbook" optionLabel="name"
                        optionValue="id" [filter]="true"  [ngClass]="{'p-disabled': isCreateDuplicateRow}" (onChange)="onTargetBookChange($event)" placeholder="Select Target Workbook" appendTo="body">
                    </p-dropdown>
                    <div *ngIf="detailsFormErrors?.selectedTargetWorkbook" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedTargetWorkbook }}</small>
                    </div>
                </div>
                <!-- <div *ngIf="isCopyMoveWBRow && !isCreateDuplicateRow" class="p-col-2 p-lg-1 p-d-flex p-ai-center p-jc-center">
                  <strong class="p-text-center">OR</strong>
                  </div> -->
                  <ng-container *ngIf="!addToModuleForm.get('selectedTargetWorkspace')?.value && isCopyMoveWBRow && !isCreateDuplicateRow">
                    <div class="p-col-12 p-lg-6" style="margin-top: 27px;">
                      <button type="button" pButton 
                          label="Create Workbook" 
                          icon="pi pi-copy" 
                          class="p-button-secondary" 
                          pTooltip="Create a new workbook using columns from an existing workbook" 
                          tooltipPosition="top"
                          (click)="createWorkbookWithSameColumns()"
                          [disabled]="currentStep === 2">
                      </button>
                  </div>                    
                  </ng-container>

            </ng-container>
        </div>
    </div>
    <div>
        <!-- Step 1: Select Workbook Row -->
        <div *ngIf="currentStep === 1">
            <div class="p-d-flex p-jc-end  p-mt-3 p-mb-3">
              <button type="button" pButton label="Add Row" icon="pi pi-plus" (click)="openAddRowPopup()"></button>
            </div>
            
            <div *ngIf="addToModuleForm.get('addRow')?.invalid && addToModuleForm.get('addRow')?.touched" class="p-invalid p-m-3">
              <small *ngIf="addToModuleForm.get('addRow')?.errors?.required">Row is required.</small>
            </div>
            <div class="p-col-12">
              <div class="p-d-flex p-jc-between p-mb-3" *ngIf="addRowArray?.controls?.length > 0">
                <div class="p-d-flex p-ai-center">
                  <p-button 
                    [ngClass]="{
                      'p-button-success': copyAllComments,
                      'p-button-outlined': !copyAllComments
                    }"
                    icon="pi pi-copy" 
                    [label]="copyAllComments ? 'Unselect All Comments' : 'Copy All Comments'"
                    (onClick)="toggleCopyAllComments()"
                    [pTooltip]="copyAllComments ? 'Unselect copy comments for all rows' : 'Select copy comments for all rows'"
                    tooltipPosition="top">
                  </p-button>
                  <p-button 
                    *ngIf="selectedModule?.id !== caseModuleId"
                    [ngClass]="{
                      'p-button-success': copyAllDocuments,
                      'p-button-outlined': !copyAllDocuments
                    }"
                    icon="pi pi-file" 
                    [label]="copyAllDocuments ? 'Unselect All Documents' : 'Copy All Documents'"
                    (onClick)="toggleCopyAllDocuments()"
                    [pTooltip]="copyAllDocuments ? 'Unselect copy documents for all rows' : 'Select copy documents for all rows'"
                    tooltipPosition="top"
                    class="p-ml-2">
                  </p-button>
                </div>
              </div>

              <p-table [value]="addRowArray.controls" 
                [tableStyle]="{ 'min-width': '50rem' }" 
                styleClass="p-datatable-gridlines" 
                responsiveLayout="scroll" 
                [columns]="workbookColumnsForTable" 
                [autoLayout]="true" 
                [paginator]="true" 
                [rows]="10" 
                [rowsPerPageOptions]="[10, 20, 50]" 
                [totalRecords]="addRowArray?.controls?.length"
                [showCurrentPageReport]="true" 
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} selected rows"
                [paginatorDropdownAppendTo]="'body'">
                
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th class="right-border white-space-nowrap">Row Number</th>
                    <th class="right-border white-space-nowrap">
                      <div class="p-d-flex p-ai-center">
                        <span>Copy Comments</span>
                      </div>
                    </th>
                    <th class="right-border white-space-nowrap" *ngIf="selectedModule?.id !== caseModuleId">
                      <div class="p-d-flex p-ai-center">
                        <span>Copy Documents</span>
                      </div>
                    </th>
                    <th class="right-border white-space-nowrap">Action</th>
                    <ng-container *ngFor="let col of columns">
                      <ng-container *ngIf="col.enable">
                        <th pResizableColumn class="right-border white-space-nowrap">
                          {{ col?.name }}
                        </th>
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-row let-columns="columns" let-i="rowIndex">
                  <tr [formGroup]="row">
                    <td class="white-space-nowrap">{{ row.get('row')?.value?.rowNumber }}</td>
                    <td>
                      <p-inputSwitch 
                        formControlName="copyComment"
                        (onChange)="onCommentToggle()"
                        pTooltip="Copy comments for this row"
                        tooltipPosition="top">
                      </p-inputSwitch>
                    </td>
                    <td *ngIf="selectedModule?.id !== caseModuleId">
                      <p-inputSwitch 
                        formControlName="copyDocument"
                        (onChange)="onDocumentToggle()"
                        pTooltip="Copy documents for this row"
                        tooltipPosition="top">
                      </p-inputSwitch>
                    </td>
                    <td>
                      <button pButton 
                        icon="pi pi-trash" 
                        class="p-button-danger p-button-sm" 
                        tooltipPosition="top"
                        pTooltip="Remove Row {{ row.get('row')?.value?.rowNumber }}" 
                        (click)="removeWorkbookRow(i)">
                      </button>
                    </td>
                    <ng-container *ngFor="let col of columns">
                      <ng-container *ngIf="col.enable">
                        <td class="white-space-nowrap">
                          <app-shared-workbook-cell [col]="col" [workbookRow]="row.get('row')?.value"></app-shared-workbook-cell>
                        </td>
                      </ng-container>
                    </ng-container>
                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td [attr.colspan]="4 + workbookColumnsForTable.length" class="p-text-center">
                      No rows selected yet. Click "Add Row" to start selecting.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
            <p-dialog header="Select Rows to Add" [(visible)]="displayRowSelectionModal" [modal]="true" (onHide)="closeRowSelectionModal()"  [style]="{width: '70vw'}">
              <app-shared-workbook-listing
                *ngIf="selectedWorkbook?.intId"
                #sharedWorkbookListing
                [workbookIntId]="selectedWorkbook?.intId"
                [multiSelect]="true"
                [showSelection]="true"
                [selectedRowForConversion]="selectedRowForConversion"
                (onSelect)="handleMultiRowSelection($event)"
                (onWorkbookColumnsChange)="handleWorkbookColumnsChange($event)"
                >
              </app-shared-workbook-listing>
            
              <p-footer>
                <button type="button" pButton label="Cancel" class="p-button-secondary" (click)="closeRowSelectionModal()"></button>
                <button type="button" pButton label="Reset" class="p-button-secondary" (click)="resetSelection()"></button>
                <button type="button" pButton label="Save" (click)="saveSelection()"></button>
              </p-footer>
            </p-dialog>
        </div>

        <!-- Step 2: Field Mapping -->
        <div *ngIf="currentStep === 2">
            <app-wb-module-object-field-mapping *ngIf="displayFieldMapping"
            #fieldmapping
            [displayFieldMapping]="displayFieldMapping"
            [selectedModule]="selectedModule"
            [selectedChannel]="this.addToModuleForm?.value?.selectedChannel"
            [workbookIntId]="selectedWorkbook?.intId"
            [sectionColumns]="sectionColumns"
            [selectedFileHeaders]="selectedFileHeaders"
            [selectedAction]="selectedAction"
            [workspaceId]="selectedWorkspace?.id"
            [isCopyMoveWBRows]="isCopyMoveWBRow"
            (dialogClosed)="closMappingModal()"
            (importStarted)="importFileUploaded()"
            [importFileWorkbookRows]="addRowArray?.value"
            >
        </app-wb-module-object-field-mapping>
        </div>
    </div>
    </form>  
    <p-footer>
        <button type="button" pButton (click)="closeDialog()" label="Cancel" class="p-button-secondary"></button>
        <button type="button" pButton (click)="previousStep()" label="Back" class="p-button-secondary" *ngIf="currentStep === 2"></button>
        <button type="button" pButton (click)="nextStep()" label="Next" *ngIf="currentStep === 1"></button>
        <button type="button" pButton (click)="convertRowToModuleObject()" label="Save" *ngIf="currentStep === 2"></button>
    </p-footer>
</p-dialog>

<!-- Create Workbook Dialog -->
<p-dialog *ngIf="displayCreateWorkbookDialog" header="Create a new workbook using columns from an existing workbook" [(visible)]="displayCreateWorkbookDialog" [modal]="true" 
    [style]="{width: '70vw'}" [closable]="true" (onHide)="closeCreateWorkbookDialog()">
    <form [formGroup]="createWorkbookForm" novalidate>
        <div class="p-fluid">
            <!-- New Workbook Form Fields -->
            <div class="p-grid">
                <div class="p-col-12 p-lg-6">
                    <div class="p-field p-mb-3">
                        <label for="workbookName"><strong>New Workbook Name</strong> <span style="color: red;">*</span></label>
                        <input id="workbookName" type="text" pInputText formControlName="workbookName" 
                            [ngClass]="{'ng-invalid ng-dirty': createWorkbookForm.get('workbookName')?.invalid && createWorkbookForm.get('workbookName')?.touched}"
                            placeholder="Enter workbook name">
                        <small class="p-error" *ngIf="createWorkbookForm.get('workbookName')?.invalid && createWorkbookForm.get('workbookName')?.touched">
                            <span *ngIf="createWorkbookForm.get('workbookName')?.errors?.['required']">Workbook name is required</span>
                            <span *ngIf="createWorkbookForm.get('workbookName')?.errors?.['maxlength']">Maximum length is 30 characters</span>
                            <span *ngIf="createWorkbookForm.get('workbookName')?.errors?.['noWhiteSpace']">Workbook name cannot be empty</span>
                        </small>
                    </div>
                </div>

                <div class="p-col-12 p-lg-6">
                    <div class="p-field p-mb-3">
                        <label for="selectedWorkspace"><strong>Destination Workspace</strong> <span style="color: red;">*</span></label>
                        <p-dropdown id="selectedWorkspace" [options]="workspaceForCreateWB" formControlName="selectedWorkspace"
                            optionLabel="name" optionValue="id" [filter]="true" placeholder="Select Destination Workspace" appendTo="body">
                        </p-dropdown>
                        <small class="p-error" *ngIf="createWorkbookForm.get('selectedWorkspace')?.invalid && createWorkbookForm.get('selectedWorkspace')?.touched">
                            Destination workspace is required
                        </small>
                    </div>
                </div>
            </div>

            <!-- Source Selection Section -->
            <div class="p-field p-mb-3">
                <div class="section-header">
                    <i class="pi pi-copy"></i>
                    <span><strong>Source Column Selection</strong></span>
                </div>
                <div class="p-grid">
                    <div class="p-col-12 p-lg-6">
                        <label for="sourceWorkspace"><strong>Source Workspace</strong> <span style="color: red;">*</span></label>
                        <p-dropdown id="sourceWorkspace" [options]="sourceWorkspaceForCreateWB" 
                            formControlName="sourceWorkspace" optionLabel="name" optionValue="id" 
                            [filter]="true" placeholder="Select Source Workspace" appendTo="body"
                            (onChange)="onSourceWorkspaceChange($event)">
                        </p-dropdown>
                        <small class="p-error" *ngIf="createWorkbookForm.get('sourceWorkspace')?.invalid && createWorkbookForm.get('sourceWorkspace')?.touched">
                            Source workspace is required
                        </small>
                    </div>
                    <div class="p-col-12 p-lg-6">
                        <label for="sourceWorkbook"><strong>Source Workbook</strong> <span style="color: red;">*</span></label>
                        <p-dropdown id="sourceWorkbook" [options]="sourceWorkbookForCreateWB" 
                            formControlName="sourceWorkbook" optionLabel="name" optionValue="id" 
                            [filter]="true" placeholder="Select Source Workbook" appendTo="body"
                            (onChange)="onSourceWorkbookChange($event)"
                            [disabled]="!createWorkbookForm.get('sourceWorkspace')?.value">
                        </p-dropdown>
                        <small class="p-error" *ngIf="createWorkbookForm.get('sourceWorkbook')?.invalid && createWorkbookForm.get('sourceWorkbook')?.touched">
                            Source workbook is required
                        </small>
                    </div>
                </div>
            </div>

            <!-- Source Workbook Columns Table -->
            <div class="p-field p-mb-3 column-selection-table">
                <label><strong>Source Workbook Columns</strong></label>
                <p-table [value]="sourceWorkbookColumns" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm p-datatable-gridlines"  [(selection)]="selectedColumnForNewWb">
                    <ng-template pTemplate="header">
                        <tr>
                          <th class="p-col-2 p-pl-3">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                          </th>                
                            <th class="p-col-6">Column Name</th>
                            <th class="p-col-4">Data Type</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-column>
                        <tr>
                            <td>
                              <p-tableCheckbox [value]="column" [binary]="true"></p-tableCheckbox>
                            </td>
                            <td>{{column.name}}</td>
                            <td>{{column.label || 'Text'}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3" class="p-text-center">No columns available</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </form>
    <p-footer>
        <button type="button" pButton label="Cancel" class="p-button-secondary" (click)="closeCreateWorkbookDialog()"></button>
        <button type="button" pButton label="Create" (click)="submitCreateWorkbook()" ></button>
    </p-footer>
</p-dialog>